import * as React from "react";

export class PulseLoading extends React.Component<{}, {}> {
    render() {
        return (
            <div className="rj-pulse-bet-markets__pulse-loading"></div>
        );
    }
}